import { dbk_buildUsServicesMetadata } from "../../server/markets/usServicesMetadata";
import { buildRuntimeSeoMetadata, type RuntimeSeoMetadata } from "./seo";

export function dbk_buildRuntimeUsServicesMetadata(origin: string | null): RuntimeSeoMetadata {
  const catalog = dbk_buildUsServicesMetadata(origin);
  const metadata = buildRuntimeSeoMetadata("en", "home");
  return {
    ...metadata,
    htmlLang: "en-US",
    title: catalog.title,
    description: catalog.description,
    keywords: catalog.keywords,
    robots: catalog.robots,
    canonicalUrl: catalog.canonicalUrl,
    // There is no Swedish translation of this catalog. Homepage alternates
    // would falsely pair unrelated pages and must be removed on navigation.
    alternateUrl: null,
    xDefaultUrl: null,
    alternates: [],
    og: {
      ...metadata.og,
      locale: "en_US",
      alternateLocale: null,
      title: catalog.title,
      description: catalog.description,
      url: catalog.canonicalUrl,
      image: catalog.imageUrl,
      imageAlt: catalog.imageAlt,
      imageWidth: catalog.imageWidth,
      imageHeight: catalog.imageHeight
    },
    twitter: {
      ...metadata.twitter,
      title: catalog.title,
      description: catalog.description,
      image: catalog.imageUrl,
      imageAlt: catalog.imageAlt
    },
    jsonLd: catalog.jsonLd
  };
}
